export class ConsultaPublicaColeModel {

    public nombre: string;
    public apellido: string;
    public telefono: string;
    public mail: string;
    public mensaje: string;

}
